import { useNavigate } from "react-router-dom";
import Account from "../../models/account";

const AccountLink: React.FC<{ account: Account }> = ({ account }) => {
  const navigate = useNavigate();

  const onLinkClick = () => {
    navigate(`/work/accounts/${account.idAccount}`);
  };

  return (
    <div
      className="navlink"
      style={{ display: "inline-block" }}
      onClick={() => onLinkClick()}
    >
      {account.accountName}
    </div>
  );
};

export default AccountLink;
